import * as svg from "../../../assets/logout-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const LogoutIcon = iconBuilder(svg, "LogoutIcon", "0 0 20 21");
